export * from './generic-table.module';
